const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3",
  apiKey: "509b84e484bb06edf9dc9a9d07b7fb2e",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};
export default apiConfig;
